import { OnboardingFormFields } from '@Types/index';
import { otherFormSchema } from '../OtherFormSchema';
import { useFormHook } from '@Hooks/index';

export const useOtherFormLogic = () => {
  const formMethods = useFormHook({
    formSchema: otherFormSchema,
    mode: 'onChange',
    formDefaultValues: {
      [OnboardingFormFields.ACCOUNT_OPENING_REASON]: '',
    },
    schemaTitle: 'accountOpeningReason',
  });
  return { formMethods };
};
